const solutions = [
  {
    iconClass: 'fas fa-scale-balanced',
    title: 'Data Reconciliation',
    body: [
      { icon: 'fas fa-database', text: 'ERP and RCM Data Tie-out' },
      {
        icon: 'fas fa-shield-check',
        text: 'Ensure downstream GP and GTN compliance',
      },
      { icon: 'fas fa-bullseye', text: 'Single Source of Truth' },
      { icon: 'fas fa-comments', text: 'AI Commentary' },
    ],
  },
  {
    iconClass: 'fas fa-filter-circle-dollar',
    title: 'Gross-To-Net',
    body: [
      {
        icon: 'fas fa-chart-line-up',
        text: 'Streamlined Reserve Balance Tracking',
      },
      { icon: 'fas fa-sliders-h', text: 'Efficient Reserve Management' },
      { icon: 'fas fa-chart-pie', text: 'Configurable Dashboards and Reports' },
    ],
  },
  {
    iconClass: 'fas fa-heart-pulse',
    title: 'Medicaid End-to-End',
    body: [
      { icon: 'fas fa-robot', text: 'Invoice Retrieval RPA' },
      { icon: 'fas fa-circle-check', text: 'Summary and CLD Validation' },
      // { icon: 'fas fa-clone', text: '340B Duplicate Detectio' },
      { icon: 'fas fa-robot', text: 'Invoice Submission RPA' },
      { icon: 'fas fa-scale-balanced', text: 'Dispute Analysis Reporting' },
    ],
  },
  {
    iconClass: 'fas fa-landmark',
    title: 'IRA',
    body: [
      {
        icon: 'fas fa-circle-dollar',
        text: 'Maximum Fair Price Effectuation (MFP)',
      },
      { icon: 'fas fa-tags', text: 'Manufacturer Discount Program (MDP)' },
      { icon: 'fas fa-syringe', text: 'Part B Inflation Penalties' },
    ],
  },
  {
    iconClass: 'fas fa-file-contract',
    title: 'Distributor Agreements',
    body: [
      { icon: 'fas fa-calculator', text: 'Streamlined Rebate Calculation' },
      {
        icon: 'fas fa-shield-plus',
        text: 'Audit-Ready BFSF and NBFSF Classification',
      },
      { icon: 'fas fa-chart-bar', text: 'Reporting and Analytics' },
    ],
  },
];

export default solutions;
